import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Menu } from "antd";
import { USER_STORAGE, ROLE_USER, ROLE_ADMIN } from "constants/index";
import { useSelector } from "react-redux";
import { selectRole } from "reducer/login/login-user";
import { Kanban, Laptop, Menu as MenuIcon } from "lucide-react";
import { GetPropsMenu } from "./menu-custom";

const { Sider } = Layout;

const MenuApp = () => {
  const navigate = useNavigate();
  const [roleRedux, setRoleRedux] = useState(useSelector(selectRole));
  const [collapsed, setCollapsed] = useState(false);
  const customMenu = GetPropsMenu(location.pathname);

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null && roleRedux == "") {
      const { role } = JSON.parse(localStorageItem);
      setRoleRedux(role);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1350) {
        // ajuste o valor conforme necessário
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };

    window.addEventListener("resize", handleResize);

    // Chame a função uma vez para definir o estado inicial
    handleResize();

    // Limpe o event listener quando o componente for desmontado
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function getItem(label, key, icon, children, type, router) {
    return {
      key,
      icon,
      children,
      label,
      type,
      onClick: () => {
        if (router) navigate(router);
      },
    };
  }
  const itemsAdm = [
    getItem(
      "Painel Gerencial",
      "managerial",
      <Kanban size={15} />,
      null,
      null,
      "/app/admin/managerial"
    ),
    getItem(
      "Acessos",
      "users",
      <Laptop size={15} />,
      null,
      null,
      "/app/admin/users"
    ),
    ,
  ];

  const itemsUser = [
    getItem(
      "Painel Gerencial",
      "managerial",
      <Kanban size={15} />,
      null,
      null,
      "/app/customer/managerial"
    ),
  ];
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  const items = roleRedux === ROLE_ADMIN ? itemsAdm : itemsUser;

  if (outerWidth < 501) {

    return (
      <Menu
        mode="horizontal"
        theme="dark"
        defaultSelectedKeys={[customMenu.defaultSelectedKeys]}
        items={items}
      />
    );
  }

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={() => toggleCollapsed()}
      className="container-sider"
      id="siderMenu"
      width={"15%"}
      trackStyle={{ backgroundColor: "#12475c" }}
    >
      <div className="top-menu">
        <div
          onClick={toggleCollapsed}
          style={{
            marginBottom: 16,
            cursor: "pointer",
            color: "#ffffff",
            textAlign: "end",
            paddingRight: "15px",
          }}
        >
          {collapsed ? <MenuIcon size={20} /> : <MenuIcon size={20} />}
        </div>
        {/*!collapsed && <img className="logo-login" src={LOGO} alt="Logo" />*/}
      </div>

      <div className="body-menu">
        <Menu
          mode="inline"
          theme="dark"
          defaultSelectedKeys={[customMenu.defaultSelectedKeys]}
          items={items}
        />
      </div>
    </Sider>
  );
};

export default MenuApp;
